// This file was generated by a custom prisma generator, do not edit manually.
/* eslint-disable ts/no-redeclare */
export const DemisTrigger = {
  symptomDiaryEntryCreation: 'symptomDiaryEntryCreation',
  caseConfirmation: 'caseConfirmation',
} as const

export type DemisTrigger = (typeof DemisTrigger)[keyof typeof DemisTrigger]

export const DocumentScanStatus = {
  Pending: 'Pending',
  Passed: 'Passed',
  Failed: 'Failed',
  Skipped: 'Skipped',
} as const

export type DocumentScanStatus = (typeof DocumentScanStatus)[keyof typeof DocumentScanStatus]

export const HeatProtectionContactGender = {
  Male: 'Male',
  Female: 'Female',
  Other: 'Other',
} as const

export type HeatProtectionContactGender = (typeof HeatProtectionContactGender)[keyof typeof HeatProtectionContactGender]

export const HeatProtectionRiskScale = {
  None: 'None',
  Low: 'Low',
  Medium: 'Medium',
  High: 'High',
} as const

export type HeatProtectionRiskScale = (typeof HeatProtectionRiskScale)[keyof typeof HeatProtectionRiskScale]

export const HeatProtectionApartmentType = {
  Alone: 'Alone',
  Shared: 'Shared',
} as const

export type HeatProtectionApartmentType = (typeof HeatProtectionApartmentType)[keyof typeof HeatProtectionApartmentType]

export const HeatProtectionMedicationIntake = {
  None: 'None',
  One: 'One',
  TwoToFour: 'TwoToFour',
  OverFour: 'OverFour',
} as const

export type HeatProtectionMedicationIntake = (typeof HeatProtectionMedicationIntake)[keyof typeof HeatProtectionMedicationIntake]

export const HeatProtectionMobilityRestriction = {
  None: 'None',
  LowDistance: 'LowDistance',
  Walker: 'Walker',
  Wheelchair: 'Wheelchair',
  Bedridden: 'Bedridden',
} as const

export type HeatProtectionMobilityRestriction = (typeof HeatProtectionMobilityRestriction)[keyof typeof HeatProtectionMobilityRestriction]

export const HeatProtectionGenericHealthRestriction = {
  None: 'None',
  Low: 'Low',
  Medium: 'Medium',
  High: 'High',
  Unknown: 'Unknown',
} as const

export type HeatProtectionGenericHealthRestriction = (typeof HeatProtectionGenericHealthRestriction)[keyof typeof HeatProtectionGenericHealthRestriction]

export const HeatProtectionDiabetesRestriction = {
  None: 'None',
  Diet: 'Diet',
  Insulin: 'Insulin',
  Pills: 'Pills',
} as const

export type HeatProtectionDiabetesRestriction = (typeof HeatProtectionDiabetesRestriction)[keyof typeof HeatProtectionDiabetesRestriction]

export const HeatProtectionRenalInsufficiencyRestriction = {
  None: 'None',
  DrinkingLimit: 'DrinkingLimit',
  Dialysis: 'Dialysis',
} as const

export type HeatProtectionRenalInsufficiencyRestriction = (typeof HeatProtectionRenalInsufficiencyRestriction)[keyof typeof HeatProtectionRenalInsufficiencyRestriction]

export const HeatProtectionMarketingChannel = {
  Letter: 'Letter',
  Internet: 'Internet',
  Postcard: 'Postcard',
  Press: 'Press',
  Other: 'Other',
} as const

export type HeatProtectionMarketingChannel = (typeof HeatProtectionMarketingChannel)[keyof typeof HeatProtectionMarketingChannel]

export const HeatProtectionCareSituation = {
  None: 'None',
  Household: 'Household',
  Relatives: 'Relatives',
  ServiceWeekly: 'ServiceWeekly',
  ServiceRegularly: 'ServiceRegularly',
  ServiceDaily: 'ServiceDaily',
} as const

export type HeatProtectionCareSituation = (typeof HeatProtectionCareSituation)[keyof typeof HeatProtectionCareSituation]

export const HeatProtectionCareCoverage = {
  Covered: 'Covered',
  NotCovered: 'NotCovered',
} as const

export type HeatProtectionCareCoverage = (typeof HeatProtectionCareCoverage)[keyof typeof HeatProtectionCareCoverage]

export const HeatProtectionConsultationTopic = {
  Diet: 'Diet',
  Routine: 'Routine',
  TemperatureControl: 'TemperatureControl',
  Medication: 'Medication',
  UV: 'UV',
  HeatPortal: 'HeatPortal',
  WeatherService: 'WeatherService',
  Organisation: 'Organisation',
  Supplies: 'Supplies',
} as const

export type HeatProtectionConsultationTopic = (typeof HeatProtectionConsultationTopic)[keyof typeof HeatProtectionConsultationTopic]

export const HeatProtectionFrailtyScore = {
  VeryFit: 'VeryFit',
  Well: 'Well',
  ManagingWell: 'ManagingWell',
  Vulnerable: 'Vulnerable',
  MildlyFrail: 'MildlyFrail',
  ModeratelyFrail: 'ModeratelyFrail',
  SeverelyFrail: 'SeverelyFrail',
  VerySeverelyFrail: 'VerySeverelyFrail',
  TerminallyIll: 'TerminallyIll',
} as const

export type HeatProtectionFrailtyScore = (typeof HeatProtectionFrailtyScore)[keyof typeof HeatProtectionFrailtyScore]

export const HeatProtectionPreExistingHeatDiseases = {
  Obesity: 'Obesity',
  Carcinoma: 'Carcinoma',
  Other: 'Other',
} as const

export type HeatProtectionPreExistingHeatDiseases = (typeof HeatProtectionPreExistingHeatDiseases)[keyof typeof HeatProtectionPreExistingHeatDiseases]

export const HeatProtectionCallType = {
  Reception: 'Reception',
  Warning: 'Warning',
  Other: 'Other',
} as const

export type HeatProtectionCallType = (typeof HeatProtectionCallType)[keyof typeof HeatProtectionCallType]

export const HeatProtectionCallStatus = {
  Pending: 'Pending',
  Active: 'Active',
  Completed: 'Completed',
  NotAnswered: 'NotAnswered',
  Busy: 'Busy',
} as const

export type HeatProtectionCallStatus = (typeof HeatProtectionCallStatus)[keyof typeof HeatProtectionCallStatus]

export const HeatProtectionCallCreatedByType = {
  Automation: 'Automation',
  User: 'User',
} as const

export type HeatProtectionCallCreatedByType = (typeof HeatProtectionCallCreatedByType)[keyof typeof HeatProtectionCallCreatedByType]

export const HeatProtectionHitzeKniggeTransferMethod = {
  Email: 'Email',
  Post: 'Post',
} as const

export type HeatProtectionHitzeKniggeTransferMethod = (typeof HeatProtectionHitzeKniggeTransferMethod)[keyof typeof HeatProtectionHitzeKniggeTransferMethod]

export const HeatLoadWarningLevelType = {
  HighHeatLoad: 'HighHeatLoad',
  ExtremeHeatLoad: 'ExtremeHeatLoad',
} as const

export type HeatLoadWarningLevelType = (typeof HeatLoadWarningLevelType)[keyof typeof HeatLoadWarningLevelType]

export const HeatProtectionWarningProtocolMethod = {
  Email: 'Email',
  Sms: 'Sms',
  Phone: 'Phone',
} as const

export type HeatProtectionWarningProtocolMethod = (typeof HeatProtectionWarningProtocolMethod)[keyof typeof HeatProtectionWarningProtocolMethod]
